var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-treeview',{ref:"moTree",attrs:{"id":"moTree","fields":_vm.fields},on:{"nodeSelected":_vm.moTreeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }